import { render } from "./ModalInserirNosSelecionados.vue?vue&type=template&id=041cfc80&scoped=true&ts=true"
import script from "./ModalInserirNosSelecionados.vue?vue&type=script&lang=ts"
export * from "./ModalInserirNosSelecionados.vue?vue&type=script&lang=ts"

import "./ModalInserirNosSelecionados.vue?vue&type=style&index=0&id=041cfc80&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-041cfc80"]])

export default __exports__